// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--font-family-base:\"Nunito\",sans-serif;--font-size:13px;--font-size-header:28px;--hover-color:#337ab7;--brand-color:#337ab7;--border-color:#ddd;--notification-color:#ff5a5f;--max-content-width:1000px;--screen-xs-min:480px;--screen-sm-min:768px;--screen-md-min:992px;--screen-lg-min:1200px}._2VuHt{padding-left:20px;padding-right:20px;padding-top:40px}.QOUG7{margin:0 auto;padding:0 0 40px;max-width:800px;max-width:calc(var(--max-content-width)*0.8)}", ""]);
// Exports
exports.locals = {
	"root": "_2VuHt",
	"container": "QOUG7"
};
module.exports = exports;
